import img from '../../helpers/img';

export default {
  title: 'Freeland',
  tile: {
    grid: 'col-12 lap-3',
    bgImage: img('freeland/freeland-hero.jpg')
  },
  hero: {
    bgImage: img('freeland/freeland-hero.jpg'),
    bgPosition: 'top'
  },
  info: {
    client: 'Freeland Design',
    timeline: 'Nov 2015',
    description: [
      'FreelandDesign.com is a static site generated for a San Francisco based micro-agency that I had the pleasure of working with.',
      'I collaborated with Kevin Freeland, the company\'s founder, who provided the design.'
    ],
    tools: `
      NPM,
      Node,
      Jade,
      SCSS,
      JS (ES6)
    `,
    buttons: [{
      text: 'VIEW WEBSITE',
      url: '//www.freelanddesign.com'
    }]
  },
  assets: [
    {
      grid: 'col-12 lap-6 desk-12',
      thumb: img('freeland/freeland-hero.jpg'),
      caption: 'Freeland Design Hero'
    },
    {
      grid: 'col-12 mob-l-6 tab-12 lap-6',
      thumb: img('freeland/freeland-design.jpg'),
      caption: 'Freeland Design - UX'
    },
    {
      grid: 'col-12 mob-l-6 tab-12 lap-6',
      thumb: img('freeland/freeland-team.jpg'),
      caption: 'Freeland Design - The Team'
    },
    {
      grid: 'col-12 mob-l-6 tab-12 lap-6',
      thumb: img('freeland/freeland-work.jpg'),
      caption: 'Freeland Design - Our Work'
    }
  ]
};



// WEBPACK FOOTER //
// ./src/fixtures/projects/freeland.js